const open = document.querySelector('.icon-info-black');
const modal = document.querySelector('.product__price-modal');

if (open && modal) {
  open.addEventListener('mouseover', () => {
    modal.classList.add('open');
  });
  open.addEventListener('mouseout', () => {
    modal.classList.remove('open');
  });
}
